<div>
  
  <sl-alert open type="warning">
    <sl-icon slot="icon" name="info-circle"></sl-icon>
    <span i18n>BEWARE: This will postpone the entire plan from the selected date. You cannot undo this.</span></sl-alert>
  <sl-input label="From date" i18n-label [(ngModel)]="date" type="date" class="mt-4"></sl-input>

  <sl-select label="Period" i18n-label [(ngModel)]="days" class="mt-4" hoist>
    <sl-menu-item value="7" i18n>1 week</sl-menu-item>
    <sl-menu-item value="14" i18n>2 weeks</sl-menu-item>
    <sl-menu-item value="21" i18n>3 weeks</sl-menu-item>
    <sl-menu-item value="28" i18n>4 weeks</sl-menu-item>
    <sl-menu-item value="35" i18n>5 weeks</sl-menu-item>
    <sl-menu-item value="42" i18n>6 weeks</sl-menu-item>
    <sl-menu-item value="49" i18n>7 weeks</sl-menu-item>
    <sl-menu-item value="56" i18n>8 weeks</sl-menu-item>
  </sl-select>
  <div class="notice mt-4" i18n>Note: When the entire schedule is moved, tasks scheduled for specific dates may no
    longer be scheduled correctly.</div>
</div>
<div class="footer mt-8">
  <sl-button i18n (click)="cancel()">Cancel</sl-button>
  <sl-button type="danger" i18n [disabled]="invalidDate" (click)="accept()">Postpone entire plan</sl-button>
</div>